import colors from './colors'
import { fontFamilies, fontSizes } from './fonts'
import typography from './typography'

const breakpoints = {
  sm: 480,
  md: 768,
  lg: 1024
} as const

// Max-width (mobile-down) media queries. The admin is desktop-first, so responsive
// rules are layered UNDER these breakpoints — desktop styles are never touched.
const media = {
  belowSm: `@media (max-width: ${breakpoints.sm}px)`,
  belowMd: `@media (max-width: ${breakpoints.md}px)`,
  belowLg: `@media (max-width: ${breakpoints.lg}px)`
} as const

const theme = {
  colors,
  typography,
  fontSizes,
  fonts: fontFamilies,
  spacing: [0.5, 0.8, 1, 1.6, 2.2, 2.4, 3.0, 3.2, 4.0, 4.8, 6.8] as const,
  breakpoints,
  animations: {
    duration: '200ms',
    timingFunction: 'ease-in-out'
  } as const
}

export { media, breakpoints }
export default theme
